import React, {memo} from "react"
import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import Text from "@kaspernj/api-maker/build/utils/text"
import {View} from "react-native"

export default memo(shapeComponent(class RoutesUserMyUsersDaysSinceLastActivity extends ShapeComponent {
  static propTypes = propTypesExact({
    days: PropTypes.number.isRequired
  })

  render() {
    const {days} = this.p
    let backgroundColor

    if (days <= 7) {
      backgroundColor = "#84daa6"
    } else if (days <= 14) {
      backgroundColor = "#ffe88f"
    } else {
      backgroundColor = "#fab0a6"
    }

    return (
      <View style={{flexDirection: "row", alignItems: "center"}}>
        <View
          style={this.cache("iconStyle", {
            marginRight: 10,
            width: 8,
            height: 8,
            backgroundColor,
            borderRadius: "50%"
          }, [backgroundColor])}
        />
        <Text>
          {days}
        </Text>
      </View>
    )
  }
}))
